var styles = {
  "Checkbox": "Polaris-OptionList-Checkbox",
  "active": "Polaris-OptionList-Checkbox--active",
  "Backdrop": "Polaris-OptionList-Checkbox__Backdrop",
  "Input": "Polaris-OptionList-Checkbox__Input",
  "Input-indeterminate": "Polaris-OptionList-Checkbox__Input--indeterminate",
  "Icon": "Polaris-OptionList-Checkbox__Icon",
  "hover": "Polaris-OptionList-Checkbox--hover"
};

export { styles as default };
